import { useQuery } from '@tanstack/react-query';
import { FreelancerService } from '../../services/freelancer';
import { IBaseUseQueryProps } from '../../interfaces/baseUseQueryProps';
import { IBlobResponse } from '../../interfaces/blobResponse';

interface IProps extends IBaseUseQueryProps<IBlobResponse> {
  id: number;
}
export const GET_FREELANCER_RESUME_QUERY_KEY = 'get-resume';

export const useGetFreelancerResume = ({id, ...props}: IProps) => useQuery({
  queryKey: [GET_FREELANCER_RESUME_QUERY_KEY],
  queryFn: () => FreelancerService.getResume(id),
  refetchOnWindowFocus: false,
  retry: false,
  ...props
});